/**
 * parse to pixel
 *
 * @param {number} value
 * @returns {string}
 */
export const parseToPixel = vl => {
  if (!vl) return '1px';
  return typeof vl === 'string' ? vl : `${vl}px`;
};